import { render, staticRenderFns } from "./ActaSeguimiento.vue?vue&type=template&id=25ab9424&scoped=true"
import script from "./ActaSeguimiento.vue?vue&type=script&lang=js"
export * from "./ActaSeguimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ab9424",
  null
  
)

export default component.exports